import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { InputFieldBaseComponent } from './input-field-base.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { NgStyle } from '@angular/common';
import { ExtendedModule } from '@ngbracket/ngx-layout/extended';

@Component({
  selector: 'mng-inputfield-boolean',
  imports: [MatCheckbox, ReactiveFormsModule, NgStyle, ExtendedModule],
  template: `
    <mat-checkbox
      [id]="field().id"
      [formControl]="field().control"
      [labelPosition]="labelPosition()"
      (change)="changeHandler.emit($event.checked)"
    >
      @if (showPlaceholder()) {
        <span [ngStyle]="labelStyle()"> {{ field().label }} </span>
      }
    </mat-checkbox>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldBooleanComponent extends InputFieldBaseComponent {
  readonly suffix = input<string>();
  readonly showPlaceholder = input(true, { transform: booleanAttribute });
  readonly labelPosition = input<'before' | 'after'>('after');
  readonly labelStyle = input<Record<string, string>>();
  readonly changeHandler = output<boolean>();
}
